import React, { useEffect, useRef, useState } from "react";
import { Modal } from "components/Modal";
import { Button } from "components/Button";
import styles from "css_modules/LoadAIModal.module.css";
import { useFetch } from "helpers/hooks";
//import { request } from "helpers/tools";
import * as pdfjsLib from "pdfjs-dist";
import "pdfjs-dist/build/pdf.worker.entry";

export const LoadAIModal = ({ close, user, doc,loadFromAI, docTypes }) => {

  

  const doc0 = `/archive/bb0cbe00-61ad-45ed-99be-dea8504328ee/`;
  const doc1 = `/archive/5877359d-fba5-460c-8891-72933985122b/`;
  const doc2 = `/archive/ab6bf476-f7d9-4f24-b0eb-fb7732edfc15/`;
  const doc0detail = `/detail/bb0cbe00-61ad-45ed-99be-dea8504328ee/`;
  const doc1detail = `/detail/5877359d-fba5-460c-8891-72933985122b/`;
  const doc2detail = `/detail/ab6bf476-f7d9-4f24-b0eb-fb7732edfc15/`;

  const docs = [useFetch(doc0), useFetch(doc1), useFetch(doc2)];
  const docsDetails = [useFetch(doc0detail), useFetch(doc1detail), useFetch(doc2detail)];
  const isLoading = docs.some((d) => d.loading);

  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [mousePos, setMousePos] = useState({ x: 0, y: 0 });

  const canvasRef = useRef(null);

  const previewIndex = hoveredIndex;

  const previewDocUuid =
    previewIndex !== null ? docs[previewIndex]?.data?.uuid : null;

  const docUrl = previewDocUuid
    ? `/archive/${previewDocUuid}/`
    : "";

  const selectedDoc = useFetch(docUrl);

  const pdfUrl = selectedDoc?.data?.file_url;
  const isPdf = pdfUrl && pdfUrl.toLowerCase().includes(".pdf");

  useEffect(() => {
    if (!isPdf || !pdfUrl || !canvasRef.current) return;

    const loadPdf = async () => {
      try {
        const loadingTask = pdfjsLib.getDocument(pdfUrl);
        const pdf = await loadingTask.promise;
        const page = await pdf.getPage(1);

        const viewport = page.getViewport({ scale: 1.5 });
        const canvas = canvasRef.current;
        const context = canvas.getContext("2d");

        canvas.height = viewport.height;
        canvas.width = viewport.width;

        await page.render({
          canvasContext: context,
          viewport,
        }).promise;
      } catch (err) {
        console.error("PDF load error:", err);
      }
    };

    loadPdf();
  }, [pdfUrl, isPdf, previewIndex]);

  if (isLoading) {
    return (
      <div className={styles.ontop}>
        <Modal name={"Nabízené doklady"} close={close}>
          <div
            className={styles.docColumn}
            style={{ padding: "2rem" }}
          >
            Načítání dokladů...
          </div>
        </Modal>
      </div>
    );
  }

  const docsData = docs.map((d) => d.data);


    
    
    const selectTemplateOverwrite = () =>{
        if (selectedDoc){
            loadFromAI(docsDetails[selectedIndex].data,true)
            close()
        }
    }

    const selectTemplateAdd = () =>{
        if (selectedDoc){
            loadFromAI(docsDetails[selectedIndex].data,false)
            close()
        }
    }

  return (
    <div className={styles.ontop}>
      <Modal name={"Nabízené doklady"} close={close}>
        <div className={styles.docColumn}>
          <table className={styles.table}>
            <thead>
              <tr>
                <th className={styles.th}>#</th>
                <th className={styles.th}>Popis dokladu</th>
                <th className={styles.th}>Partner</th>
              </tr>
            </thead>

            <tbody>
              {docsData.map((d, index) => {
                const isSelected = selectedIndex === index;

                return (
                  <React.Fragment key={index}>
                    <tr
                      className={`${styles.tr} ${
                        isSelected ? styles.selectedRow : ""
                      }`}
                      onClick={() =>
                        setSelectedIndex((prev) =>
                          prev === index ? null : index
                        )
                      }
                      onMouseEnter={() => setHoveredIndex(index)}
                      onMouseLeave={() => setHoveredIndex(null)}
                      onMouseMove={(e) =>
                        setMousePos({
                          x: e.clientX,
                          y: e.clientY,
                        })
                      }
                    >
                      <td className={styles.td}>{index + 1}</td>

                      <td className={styles.td}>
                        {d?.document_info?.document_identifier || "—"}
                      </td>

                      <td className={styles.td}>
                        {d?.document_info?.supplier_title || "—"}
                      </td>
                    </tr>

                    {isSelected && (
                      <tr className={styles.expandedRow}>
                        <td colSpan={3}>
                          <div className={styles.expandWrapper}>
                            <div className={styles.inlineActions}>
                              
                              <Button primary onClick={selectTemplateOverwrite} >Načíst data</Button>
                              <Button primary onClick={selectTemplateAdd}       >Doplnit data</Button>
                            </div>
                          </div>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                );
              })}
            </tbody>
          </table>
        </div>

        {isPdf && hoveredIndex !== null && (
          <div
            className={styles.hoverPreview}
            style={{
              top: mousePos.y + 15,
              left: mousePos.x + 15,
            }}
          >
            <canvas
              ref={canvasRef}
              className={styles.pdfCanvas}
            />

            <div className={styles.previewMeta}>
              <div>
                <strong>Partner:</strong>{" "}
                {selectedDoc?.data?.document_info?.supplier_title || "—"}
              </div>
              <div>
                <strong>Popis dokladu:</strong>{" "}
                {selectedDoc?.data?.document_info?.document_identifier || "—"}
              </div>
              <div>
                <strong>Datum:</strong>{" "}
                {selectedDoc?.data?.document_info?.date || "—"}
              </div>
              <div>
                <strong>Typ dokladu:</strong>{" "}
                {docTypes.find(item => item.slug === selectedDoc?.data?.document_info?.document_type)?.name || "-"}
              </div>
              <div>
                <strong>Středisko:</strong>{" "}
                {selectedDoc?.data?.document_info?.centre_title || "—"}
              </div>
              <div>
                <strong>Číselná řada:</strong>{" "}
                {selectedDoc?.data?.document_info?.num_series_title || "—"}
              </div>
              <div>
                <strong>Předkontace:</strong>{" "}
                {selectedDoc?.data?.document_info?.account_code_title || "—"}
              </div>
            </div>
          </div>
        )}
      </Modal>
    </div>
  );
};